import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ToastError = ({ error, resetError }) => {
  return (
    <>
      {toast.error(`${error}`, {
        position: "top-right",
        hideProgressBar: false,
        className: "",
        progress: undefined,
        toastId: "",
        closeOnClick: true,
        theme: "light",
        onClose: () => resetError(),
      })}
      <ToastContainer />
    </>
  );
};

export default ToastError;
